





























































































































































import { dateFormat } from "@/utils/timeFormat";
import { geTmaterialLibraryApi, geTmaterialLibraryInter } from "@/api/home";
import { Vue, Component } from "vue-property-decorator";
import { createOperationLogApi } from "@/api/store";
@Component
export default class extends Vue {
  searchInfo = {
    name: "",
    sort_field: "",
    sort_type: "",
  };
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  flacDialogVisible: boolean = false;
  flacDialogSrc = "";
  flacDialogName = "";
  pid: number = 0;
  rootDirectory: boolean = true; // 是否根目录
  crumbs: any = [];
  backgrade: boolean = false;
  componentKey: number = 0;
  selectList: any = [];
  created() {
    this.getList({
      page: 1,
      page_size: 10,
      pid: this.pid,
    });
  }
  handleSelectionChange(val: any) {
    this.selectList = val;
  }
  handleSelectDownLoad() {
    if (this.selectList.length > 0) {
      this.selectList.map((item: any) => {
        this.handleDownload(item);
      });
    }
  }
  enterPackage(val: any) {
    this.getList({
      page: 1,
      page_size: this.pageSize,
      pid: val.material_id,
    });
    this.rootDirectory = false;
    this.crumbs.push(val);
    if (this.crumbs.length > 0) {
      this.backgrade = true;
    }
  }
  nextTable(val: any) {
    if (val.is_folder === 1) {
      this.searchInfo.name = "";
      this.searchInfo.sort_field = "";
      this.searchInfo.sort_type = "";
      this.page = 1;
      this.pageSize = 10;
      this.crumbs.push(val);
      this.getList({
        page: 1,
        page_size: this.pageSize,
        pid: val.material_id,
      });
      this.rootDirectory = false;
      this.backgrade = true;
      this.getCacheItemInfo(this.crumbs[this.crumbs.length - 1]);
    }
  }
  backclicktag() {
    const arr = this.crumbs.slice(0, this.crumbs.length - 1);
    this.crumbs = arr;
    this.setCacheItemInfo(this.crumbs);
    if (this.crumbs.length === 0) {
      this.backgrade = false;
      this.pid = 0;
      this.rootDirectory = true;
    } else {
      this.pid =
        this.crumbs.length >= 1
          ? this.crumbs[this.crumbs.length - 1].material_id
          : this.pid;
      this.rootDirectory = false;
    }
    this.getList({
      page: this.page,
      page_size: this.pageSize,
      pid: this.pid,
    });
  }
  mianbaoClick(item: any, index: number) {
    const arr = this.crumbs.slice(0, index + 1);
    this.crumbs = arr;
    this.setCacheItemInfo(this.crumbs);
    this.getList({
      page: this.page,
      page_size: this.pageSize,
      pid: item.material_id,
    });
  }
  getList(params: { page: number; page_size: number; pid: number }) {
    const option: geTmaterialLibraryInter = {
      page: params.page,
      page_size: params.page_size,
      pid: params.pid,
    };
    if (this.searchInfo.name) {
      option.name = this.searchInfo.name;
    }
    if (this.searchInfo.sort_field) {
      option.sort_field = this.searchInfo.sort_field;
    }
    if (this.searchInfo.sort_type) {
      option.sort_type = this.searchInfo.sort_type;
    }
    geTmaterialLibraryApi(option).then((res: any) => {
      if (res.error_code === 0) {
        // 如果最外层只有一条数据,直接进入到第二层
        if (res.data.list.length === 1 && option.pid === 0) {
          option.pid = res.data.list[0].material_id;
          this.pid = res.data.list[0].material_id;
          geTmaterialLibraryApi(option).then((r: any) => {
            r.data.list.map((item: any) => {
              // 不是文件夹没有文件后缀的拼上文件后缀
              if (
                item.name.indexOf(item.suffix) === -1 &&
                item.is_folder === 2
              ) {
                item.name += `.${item.suffix}`;
              }
              item.update_time = dateFormat(
                "YYYY-mm-dd HH:MM",
                item.update_time * 1000
              );
              item.hidePreview = /\.(xls|xlsx|doc|docx)$/.test(item.name);
              item.downloading = false;
            });
            this.tableData = r.data.list;
            this.total = r.data.total;
            this.rootDirectory = false;
            this.page = r.data.page;
          });
        } else {
          res.data.list.map((item: any) => {
            // 不是文件夹没有文件后缀的拼上文件后缀
            if (item.name.indexOf(item.suffix) === -1 && item.is_folder === 2) {
              item.name += `.${item.suffix}`;
            }
            item.update_time = dateFormat(
              "YYYY-mm-dd HH:MM",
              item.update_time * 1000
            );
            item.hidePreview = /\.(xls|xlsx|doc|docx)$/.test(item.name);
            item.downloading = false;
          });
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.page = res.data.page;
          // 让分页组件重载更新页码
          if (option.pid !== 0) {
            setTimeout(() => {
              this.componentKey++;
            }, 1);
          }
        }
      }
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
      pid:
        this.crumbs.length >= 1
          ? this.crumbs[this.crumbs.length - 1].material_id
          : this.pid,
    });
    this.page = 1;
    this.getCacheItemInfo(this.crumbs[this.crumbs.length - 1]);
  }
  // 保存每一层的搜索信息
  getCacheItemInfo(item: any) {
    if (this.crumbs.length >= 1) {
      item.search_name = this.searchInfo.name;
      item.sort_field = this.searchInfo.sort_field;
      item.sort_type = this.searchInfo.sort_type;
      item.page = this.page;
      item.pageSize = this.pageSize;
    }
  }
  // 设置每一层的缓存信息
  setCacheItemInfo(item: any[]) {
    const it = item[item.length - 1];
    if (item.length >= 1 && it.search_name) {
      this.searchInfo.name = it.search_name;
    } else {
      this.searchInfo.name = "";
    }
    if (item.length >= 1 && it.sort_field) {
      this.searchInfo.sort_field = it.sort_field;
    } else {
      this.searchInfo.sort_field = "";
    }
    if (item.length >= 1 && it.sort_type) {
      this.searchInfo.sort_type = it.sort_type;
    } else {
      this.searchInfo.sort_type = "";
    }
    if (item.length >= 1 && it.page) {
      this.page = Number(it.page);
    } else {
      this.page = 1;
    }
    if (item.length >= 1 && it.pageSize) {
      this.pageSize = it.pageSize;
    } else {
      this.pageSize = 10;
    }
  }
  handleSortChange(e: { order: string; prop: string }) {
    if (e.order == "descending") {
      this.searchInfo.sort_type = "desc";
    } else if (e.order == "ascending") {
      this.searchInfo.sort_type = "asc";
    } else {
      this.searchInfo.sort_type = "";
    }
    this.searchInfo.sort_field = e.prop;
    this.getList({
      page: this.page,
      page_size: this.pageSize,
      pid:
        this.crumbs.length >= 1
          ? this.crumbs[this.crumbs.length - 1].material_id
          : this.pid,
    });
    this.getCacheItemInfo(this.crumbs[this.crumbs.length - 1]);
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
      pid:
        this.crumbs.length >= 1
          ? this.crumbs[this.crumbs.length - 1].material_id
          : this.pid,
    });
    this.page = e;
    this.getCacheItemInfo(this.crumbs[this.crumbs.length - 1]);
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
      pid:
        this.crumbs.length >= 1
          ? this.crumbs[this.crumbs.length - 1].material_id
          : this.pid,
    });
    this.getCacheItemInfo(this.crumbs[this.crumbs.length - 1]);
  }
  handlePreview(row: any) {
    const type = /\.([^\\.]+)$/.exec(row.name);
    if (type && type[1]) {
      if (
        [
          "pdf",
          "jpg",
          "png",
          "jpeg",
          "mp4",
          "wav",
          "mp3",
          "xlsx",
          "docx",
          "doc",
          "xls",
          "ppt",
          "AI",
          "psd",
          "ai",
          "pptx",
        ].indexOf(type[1].toLowerCase()) >= 0
      ) {
        createOperationLogApi({
          code: 10133,
          detail: `预览了WOW学院 “${row.name}” 内容；`,
        });
        window.open(row.file_url, "_blank");
      } else if (["flac"].indexOf(type[1].toLowerCase()) >= 0) {
        createOperationLogApi({
          code: 10133,
          detail: `预览了WOW学院 “${row.name}” 内容；`,
        });
        // flac用弹窗展示
        this.flacDialogVisible = true;
        this.flacDialogSrc = row.file_url;
        this.flacDialogName = row.name;
      } else {
        this.$message({
          type: "warning",
          message: "此类文件不可预览",
        });
      }
    } else {
      this.$message({
        type: "warning",
        message: "文件类型有误",
      });
    }
  }
  handleDownload(row: any) {
    if (row.downloading) {
      return;
    }
    const type = row.name.split(".");
    if (type[1]) {
      const newArr = this.tableData;
      newArr.map((item: any) => {
        if (item.material_id === row.material_id) {
          item.downloading = true;
        }
      });
      this.tableData = newArr;
      if (row.type === 3) {
        // 图片
        const imgsrc = row.file_url;
        const image = new Image();
        // 解决跨域canvas污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = function () {
          const canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          const context: any = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          const url = canvas.toDataURL(`image/${type[1]}`); // 得到图片的base64编码数据
          const a = document.createElement("a");
          a.download = row.name;
          a.href = url;
          a.click();
        };
        image.src = imgsrc;
        this.tableData.map((item: any) => {
          if (item.material_id === row.material_id) {
            item.downloading = false;
          }
        });
      } else {
        const filePath = row.file_url;
        // 下载服务器的文件
        fetch(filePath)
          .then((res) => res.blob())
          .then((blob) => {
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style.display = "none";
            // 使用获取到的blob对象创建的url
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            // 指定下载的文件名
            a.download = row.name;
            a.click();
            document.body.removeChild(a);
            // 移除blob对象的url
            window.URL.revokeObjectURL(url);
            this.tableData.map((item: any) => {
              if (item.material_id === row.material_id) {
                item.downloading = false;
              }
            });
          })
          .catch(() => {
            this.tableData.map((item: any) => {
              if (item.material_id === row.material_id) {
                item.downloading = false;
              }
            });
          });
      }
      createOperationLogApi({
        code: 10133,
        detail: `下载了WOW学院 “${row.name}” 内容；`,
      });
    } else {
      this.$message({
        type: "warning",
        message: "文件类型有误",
      });
    }
  }
}
